/**
 * houseFacades — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {LANDSCAPE, tagline, chips, type ToilePack} from './data'

export const houseFacadesPack: ToilePack = {
    slug: 'house-facades',
    category: 'facade',
    name: 'House façades',
    tagline: tagline('renders', 'houses', 'styles'),
    chips: chips('houses', 'styles'),
    ratio: LANDSCAPE,
    readings: [
        {key: 'aframe', label: 'A-frame cabin', subject: 'an A-frame cabin by a lake, a deck and glazed gable'},
        {key: 'tiny', label: 'Tiny house', subject: 'a tiny house on wheels, a loft window and porch'},
        {key: 'townhouse', label: 'Townhouse', subject: 'a narrow three-storey townhouse with a rooftop terrace'},
    ],
    styles: [
        {key: 'timber', label: 'Timber', style: 'natural timber cladding, black metal roof', palette: 'warm interior light glowing through glass', framing: 'golden-hour exterior'},
        {key: 'white', label: 'Scandinavian', style: 'white rendered walls, pale wood details', palette: 'Scandinavian minimalism', framing: 'golden-hour exterior'},
        {key: 'brick', label: 'Industrial', style: 'reclaimed brick and corten steel', palette: 'industrial and warm', framing: 'golden-hour exterior'},
    ],
    directions: ['a barn conversion instead', 'in dark stained wood', 'one storey lower'],
}
